import { Phone } from "lucide-react";

// Always-visible floating button, same bottom-right/right-edge placement used
// on Restaurant/ProShop/Convention Hall. Icon-only circle on narrow screens -
// the Guest Retreat pages have real form fields below the fold (the booking
// form's inputs), so the full text pill's footprint is more likely to sit
// directly over a tap target there than on those simpler pages.
export default function FloatingContactButton({ phone = "01769660127" }) {
  return (
    <a
      href={`tel:${phone}`}
      className="fixed bottom-4 right-4 lg:top-1/2 lg:bottom-auto lg:-translate-y-1/2 z-50 flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-lime-500 text-white p-4 sm:px-5 sm:py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105"
    >
      <Phone className="w-5 h-5 flex-shrink-0" />
      <span className="hidden sm:inline font-semibold whitespace-nowrap">
        Contact us - {phone}
      </span>
    </a>
  );
}
